<h2 mat-dialog-title>{{ title | translate }}</h2>

<mat-dialog-content>
  <mat-form-field appearance="outline" class="clone-name-field">
    <mat-label>{{ 'Name' | translate }}</mat-label>
    <input matInput
      [(ngModel)]="cloneName"
      [placeholder]="'Template name' | translate"
      (keyup.enter)="confirm()"
      required />
      @if (isDuplicate) {
        <mat-error>{{ 'Name already exists' | translate }}</mat-error>
      }
    </mat-form-field>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button (click)="cancel()">{{ 'Cancel' | translate }}</button>
    <button mat-raised-button color="primary" [disabled]="!isValid" (click)="confirm()">
      {{ confirmLabel | translate }}
    </button>
  </mat-dialog-actions>
